var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDomain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.6 511.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M511.6,95.925V42.639c0-11.772-9.555-21.327-21.326-21.327H21.312C9.539,21.312,0,30.866,0,42.639 v53.286H511.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E9ED"
    },
    points: "511.6,490.288 0,490.288 0,63.95 511.6,63.95 511.6,367.931  "
  })), /*#__PURE__*/React.createElement("rect", {
    y: 63.95,
    style: {
      fill: "#5D9CEC"
    },
    width: 511.6,
    height: 106.65
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED5564"
    },
    d: "M42.623,42.639c0,5.886-4.763,10.647-10.648,10.647s-10.663-4.762-10.663-10.647 c0-5.887,4.777-10.664,10.663-10.664S42.623,36.752,42.623,42.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M74.598,42.639c0,5.886-4.762,10.647-10.647,10.647c-5.887,0-10.664-4.762-10.664-10.647 c0-5.887,4.777-10.664,10.664-10.664C69.836,31.975,74.598,36.752,74.598,42.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D468"
    },
    d: "M106.572,42.639c0,5.886-4.762,10.647-10.647,10.647s-10.663-4.762-10.663-10.647 c0-5.887,4.777-10.664,10.663-10.664S106.572,36.752,106.572,42.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F7FA"
    },
    d: "M373.036,106.588H53.286c-5.886,0-10.663,4.763-10.663,10.648S47.401,127.9,53.286,127.9h319.75 c5.886,0,10.663-4.777,10.663-10.663S378.922,106.588,373.036,106.588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D468"
    },
    d: "M458.298,106.588h-42.623c-5.886,0-10.663,4.763-10.663,10.648s4.777,10.663,10.663,10.663h42.623 c5.886,0,10.663-4.777,10.663-10.663S464.184,106.588,458.298,106.588z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CC153"
    },
    d: "M127.9,213.161c-5.886,0-10.663,4.777-10.663,10.664l0,0l0,0v34.52l-34.396-41.28 c-0.016-0.016-0.016-0.031-0.03-0.031l-0.016-0.031l0,0c-1.952-2.342-4.903-3.841-8.197-3.841c-5.886,0-10.647,4.777-10.647,10.664 v63.95c0,5.886,4.762,10.663,10.647,10.663s10.664-4.777,10.664-10.663v-34.505l34.441,41.327l0,0 c1.967,2.342,4.902,3.841,8.196,3.841c5.887,0,10.648-4.777,10.648-10.663l0,0v-63.95l0,0l0,0 C138.548,217.939,133.786,213.161,127.9,213.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CC153"
    },
    d: "M213.161,234.488c5.887,0,10.664-4.777,10.664-10.663c0-5.887-4.777-10.664-10.664-10.664h-42.639 c-5.886,0-10.647,4.777-10.647,10.664l0,0l0,0v63.95l0,0c0,5.886,4.762,10.663,10.647,10.663l0,0h42.639 c5.887,0,10.664-4.777,10.664-10.663c0-5.887-4.777-10.664-10.664-10.664h-31.975v-10.648h21.312 c5.886,0,10.663-4.777,10.663-10.663c0-5.886-4.777-10.663-10.663-10.663h-21.312v-10.648h31.975V234.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CC153"
    },
    d: "M298.423,213.161h-53.286c-5.887,0-10.664,4.777-10.664,10.664c0,5.886,4.777,10.663,10.664,10.663 h15.986v53.287l0,0c0,5.886,4.778,10.663,10.664,10.663c5.887,0,10.648-4.777,10.648-10.663l0,0v-53.287h15.987 c5.886,0,10.663-4.777,10.663-10.663C309.086,217.939,304.309,213.161,298.423,213.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CC153"
    },
    d: "M465.839,242.108c4.169-4.169,4.169-10.913,0-15.082c-4.153-4.153-10.913-4.153-15.066,0 l-0.016,0.016l-37.674,37.674l-15.066-15.066l0,0c-4.169-4.169-10.913-4.169-15.082-0.016c-4.153,4.169-4.153,10.913,0,15.082l0,0 l22.607,22.607l0,0l0,0c4.169,4.168,10.913,4.168,15.082,0c0,0,0-0.016,0.016-0.016L465.839,242.108L465.839,242.108z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED5564"
    },
    d: "M335.738,351.725c0-5.886-4.777-10.663-10.663-10.663c-2.951,0-5.605,1.202-7.541,3.138 l-24.435,24.435L268.664,344.2c-1.92-1.936-4.59-3.138-7.541-3.138c-5.885,0-10.663,4.777-10.663,10.663v63.95 c0,5.886,4.778,10.664,10.663,10.664c5.887,0,10.664-4.778,10.664-10.664v-38.22l13.771,13.786l0,0 c1.937,1.92,4.606,3.122,7.541,3.122c2.95,0,5.604-1.202,7.541-3.122l0,0l13.771-13.786v38.22l0,0 c0,5.886,4.777,10.664,10.664,10.664c5.886,0,10.663-4.778,10.663-10.664l0,0V351.725L335.738,351.725L335.738,351.725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED5564"
    },
    d: "M197.174,341.062c-23.544,0-42.639,19.095-42.639,42.639s19.095,42.639,42.639,42.639 s42.639-19.095,42.639-42.639S220.718,341.062,197.174,341.062z M197.174,405.012c-11.757,0-21.312-9.556-21.312-21.312 c0-11.757,9.555-21.312,21.312-21.312s21.312,9.555,21.312,21.312C218.486,395.456,208.931,405.012,197.174,405.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED5564"
    },
    d: "M101.249,362.389c7.868,0,14.754,4.293,18.454,10.647h22.842 c-4.73-18.376-21.437-31.975-41.296-31.975c-23.544,0-42.639,19.095-42.639,42.639s19.095,42.639,42.639,42.639 c19.859,0,36.565-13.6,41.296-31.976h-22.842c-3.7,6.354-10.586,10.648-18.454,10.648c-11.757,0-21.312-9.556-21.312-21.312 C79.938,371.944,89.492,362.389,101.249,362.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED5564"
    },
    d: "M455.176,398.767L440.11,383.7l15.066-15.066v-0.016l0,0c4.168-4.153,4.168-10.898,0-15.066 c-4.154-4.169-10.898-4.169-15.066,0l-0.016,0.016l-15.051,15.066l-15.066-15.066l-0.016-0.016c-4.153-4.169-10.914-4.169-15.066,0 c-4.169,4.168-4.169,10.913,0,15.066v0.016l0,0l15.066,15.066l-15.066,15.066l0,0c-4.169,4.168-4.169,10.913,0,15.082 c4.152,4.152,10.913,4.152,15.066,0l0.016-0.016l15.066-15.066l15.051,15.066l0.016,0.016c4.168,4.152,10.912,4.152,15.066,0 C459.344,409.68,459.344,402.935,455.176,398.767L455.176,398.767z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomain);
export default __webpack_public_path__ + "static/media/domain.516d5e3dbf0ffd244fcd8132054a28ef.svg";
export { ForwardRef as ReactComponent };